import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiPlus } from "react-icons/fi";
import { HiOutlineArrowsUpDown } from "react-icons/hi2";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { useAppContext, useColorMatchContext } from "../../context";
import { DropdownBtn } from "../../components";
import { PaletteCard } from "./index";
import { usePalette } from "../../utils";
import style from "./Profile.module.css";

const MyPalettes = () => {
  const { user, dispatch } = useAppContext();
  const { setColormatch } = useColorMatchContext();
  const [order, setOrder] = useState("desc");
  const { data, isLoading, isSuccess } = usePalette(user?.email, order);
  const { i18n, t } = useTranslation();
  const palettes = isSuccess
    ? [
      {
        addOne: (
          <div className={style.addBtn}>
            <FiPlus size="2rem" />
            {t("Create New Palette")}
          </div>
        ),
      },
      ...data,
    ]
    : [];
  const navigate = useNavigate();

  const handleEditPalette = async (palette) => {
    // Función para convertir una URL de imagen a un objeto File
    const convertURLToFile = async (imageURL, imageName) => {
      const response = await fetch(imageURL);
      const blob = await response.blob();
      const file = new File([blob], imageName, { type: blob.type });
      return file;
    };

    // Convertir todas las imágenes en archivos "File"
    const imageFiles = await Promise.all(
      palette.images.map(async (image) => {
        const { imageURL, imageName } = image;
        return await convertURLToFile(imageURL, imageName);
      })
    );

    // Setear las imágenes y colores en el estado
    setColormatch(palette.colors);
    imageFiles.forEach((file) => {
      dispatch({ type: "ADD_IMAGE", payload: file });
    });
    navigate(`/${i18n.language}/colormatch/${palette.id}`);
    /*  navigate(`/colormatch/${palette.id}`); */
  };

  const handleOrder = (e) => {
    const text = e.target.innerText;
    console.log(text)
    const newOrder = text === "Oldest" || text === "más antiguo" ? "asc" : "desc";
    setOrder(newOrder);
  };

  return (
    <Container className="py-4">
      <Row className=" align-items-end justify-content-between my-4">
        <Col xs="auto" className="p-0">
          <h1 className={style.myPalettesTitle}>{t("Saved Palettes")}</h1>
        </Col>
        <Col xs="auto">
          <DropdownBtn
            variant="dark"
            id="dropdown-basic"
            customClass={style.actionBtn}
            title={
              <>
                <HiOutlineArrowsUpDown /> {t("Sort by")}{" "}
                {order === "asc" ? t("Oldest") : t("Newest")}
              </>
            }
          >
            <Dropdown.Item onClick={handleOrder}>{t("Oldest")}</Dropdown.Item>
            <Dropdown.Item onClick={handleOrder}>{t("Newest")}</Dropdown.Item>
          </DropdownBtn>
          {/* Palettes Saved */}
        </Col>
      </Row>
      <Row className={`gx-1 gy-5 gx-sm-5 gy-sm-5 justify-content-start justify-content-md-start ${style.recentPalettesContainer}`}>
        {!isLoading &&
          palettes?.map((palette, index) => (
            <Col md={3} sm={6} xs={6}>
              <PaletteCard
                key={index}
                palette={palette}
                handleEditPalette={handleEditPalette}
              />
            </Col>
          ))}
      </Row>
    </Container>
  );
};

export default MyPalettes;
